import { ValueGetterParams } from "ag-grid-community";
import { formatDate } from "@/utils/helpers/date-time/datetime-format";
import { NormalizedCostWidgetTableDataType } from "@/components/pages/dashboard/components/widgets/normalized-cost-widget/utils/types/types";
import { money } from "@/utils/numeral/money";

export const normalizedCostWidgetTableMonthValueGetter = ({
  data,
}: ValueGetterParams<NormalizedCostWidgetTableDataType>) =>
  formatDate(String(data?.date ?? ""), { type: "shortMonthYear" });

export const normalizedCostWidgetTableActualCostValueGetter = ({
  data,
}: ValueGetterParams<NormalizedCostWidgetTableDataType>) => {
  const prefix = (data?.regular?.trend ?? 0) > 0 ? "+" : "";

  return `${money(data?.regular?.cost ?? 0)} ${prefix}${data?.regular?.trend ?? 0}%`;
};

export const normalizedCostWidgetTableNormalizedCostValueGetter = ({
  data,
}: ValueGetterParams<NormalizedCostWidgetTableDataType>) => {
  const prefix = (data?.normalized?.trend ?? 0) > 0 ? "+" : "";

  return `${money(data?.normalized?.cost ?? 0)} ${prefix}${data?.normalized?.trend ?? 0}%`;
};
